/**
 * Action types
 */
export enum UserTypes {
  LOAD_REQUEST = "@user/LOAD_REQUEST",
  LOAD_SUCCESS = "@user/LOAD_SUCCESS",
  LOAD_FAILURE = "@user/LOAD_FAILURE",

  LOAD_REQUEST_BY_CLIENT = "@user/LOAD_REQUEST_BY_CLIENT",

  CREATE_USER_REQUEST = "@user/CREATE_USER_REQUEST",
  REGISTER_USER_REQUEST = "@user/REGISTER_USER_REQUEST",
  CREATE_USER_SUCCESS = "@user/CREATE_USER_SUCCESS",

  UPDATE_USER_REQUEST = "@user/UPDATE_USER_REQUEST",
  UPDATE_USER_PASSWORD = "@user/UPDATE_USER_PASSWORD",
  UPDATE_USER_SUCCESS = "@user/UPDATE_USER_SUCCESS",

  LOAD_REQUEST_ADDRESS = "@user/LOAD_REQUEST_ADDRESS",
  LOAD_RESPONSE_ADDRESS = "@user/LOAD_RESPONSE_ADDRESS",
  ERROR_RESPONSE_ADDRESS = "@user/ERROR_RESPONSE_ADDRESS",

  LOAD_REQUEST_USER_BY_ID = "@user/LOAD_REQUEST_USER_BY_ID",
  LOAD_SUCCESS_USER_BY_ID = "@user/LOAD_SUCCESS_USER_BY_ID",

  LOAD_REQUEST_USER_BY_EMAIL = "@user/LOAD_REQUEST_USER_BY_EMAIL",
  LOAD_SUCCESS_USER_BY_EMAIL = "@user/LOAD_SUCCESS_USER_BY_EMAIL",

  LOAD_REQUEST_USER_DISENGAGED = "@user/lOAD_REQUEST_USER_DISENGAGED",
  LOAD_RESPONSE_USER_DISENGAGED = "@user/LOAD_RESPONSE_USER_DISENGAGED",

  SEARCH_REQUEST_USER_DISENGAGED = "@user/SEARCH_REQUEST_USER_DISENGAGED",

  SEARCH_REQUEST = "@user/SEARCH_REQUEST",

  LOAD_REQUEST_PROFESSION = "@user/LOAD_REQUEST_PROFESSION",
  LOAD_RESPONSE_PROFESSION = "@user/LOAD_RESPONSE_PROFESSION",

  LOAD_REQUEST_USER_TYPES = "@user/LOAD_REQUEST_USER_TYPES",
  LOAD_RESPONSE_USER_TYPES = "@user/LOAD_RESPONSE_USER_TYPES",
  LOAD_REQUEST_CHECK_EMAIL = "@user/LOAD_REQUEST_CHECK_EMAIL",
  LOAD_RESPONSE_CHECK_EMAIL = "@user/LOAD_RESPONSE_CHECK_EMAIL",

  LOAD_REQUEST_RECOVERY_PASSWORD = "@user/LOAD_REQUEST_RECOVERY_PASSWORD",
  LOAD_REQUEST_RECOVERY_PASSWORD_TOKEN = "@user/LOAD_REQUEST_RECOVERY_PASSWORD_TOKEN",

  LOAD_SUCCESS_RECOVERY_PASSWORD = "@user/LOAD_SUCCESS_RECOVERY_PASSWORD",

  LOAD_CONFIRM_USER = "@user/LOAD_CONFIRM_USER",
  LOAD_SUCCESS_CONFIRM = "@user/LOAD_SUCCESS_CONFIRM",

  LOAD_UPDATE_COMPANIES_LINKS = "@user/LOAD_UPDATE_COMPANIES_LINKS",
  LOAD_SUCCESS_UPDATE_COMPANIES_LINKS = "@user/LOAD_SUCCESS_UPDATE_COMPANIES_LINKS",

  LOAD_UPDATE_COMPANIES = "@user/LOAD_UPDATE_COMPANIES",
  LOAD_SUCCESS_UPDATE_COMPANIES = "@user/LOAD_SUCCESS_UPDATE_COMPANIES",

  LOAD_REQUEST_BY_EXTERNAL_ID = "@user/LOAD_REQUEST_BY_EXTERNAL_ID",
  LOAD_SUCCESS_BY_EXTERNAL_ID = "@user/LOAD_SUCCESS_BY_EXTERNAL_ID",

  LOAD_REQUEST_STORE_USER = "@user/LOAD_REQUEST_STORE_USER",
  LOAD_SUCCESS_STORE_USER = "@user/LOAD_SUCCESS_STORE_USER",

  LOAD_REQUEST_UPDATE_USER = "@user/LOAD_REQUEST_UPDATE_USER",
  LOAD_SUCCESS_UPDATE_USER = "@user/LOAD_SUCCESS_UPDATE_USER",

  CLEAN = "@user/CLEAN",
}

/**
 * Data types
 */
export interface Phones {
  _id: string;
  number: string;
  cellnumber: string;
  whatapp: string;
  telegram: string;
}

export interface SpecialtiesUserInterface {
  _id: string;
  name: string;
}

export interface UserRecoveryPassword {
  _id?: string;
  email?: string;
  token?: string;
  password: string;
  oldPassword?: string;
}

export interface ProfessionUserInterface {
  _id: string;
  name: string;
}

export interface UserTypesInterface {
  _id: string;
  name: string;
}

export interface CustomerUserInterface {
  name: string;
  _id: string;
}

export interface CompanyUserInterface {
  _id: string;
  name: string;
  customer_id?: CustomerUserInterface;
}

export interface CompanyUserLinkInterface {
  function: string | null | undefined;
  exp?: string;
  permissions?: string | UserTypeInterface;
  _id?: string;
  companie_id?: CompanyUserInterface | any;
  specialties?: string;
  user_external_id?: string;
  user_type_id?: string;
  username?: string;
  main_specialty?: string;
  active?: boolean;
  linked_at?: any;
  council?: string;
  council_number?: string;
  council_state?: string;
}

export interface UserTypeInterface {
  _id: string;
  name: string;
}

export interface MainSpecialtyInterface {
  _id: string;
  name: string;
}

export interface UserListItems {
  profession_external?: string;
  main_specialty_external?: string;
  specialties_external?: string;
  companies_links: CompanyUserLinkInterface[];
  _id: string;
  name: string;
  email: string;
  profession_id: ProfessionUserInterface;
  main_specialty_id?: any;
  created_at: string;
  address: {
    postal_code: string;
    street: string;
    number: string;
    district: string;
    city: string;
    state: string;
    complement: string;
    geolocation?: { latitude: number; longitude: number };
  };
  specialties: SpecialtiesUserInterface[];
  access_granted: boolean;
  active: boolean;
  fiscal_number: string;
  username?: string;
}

export interface UserInterface {
  _id?: string;
  access_granted?: boolean;
  companies: CompanyUserInterface[];
  companies_links: CompanyUserLinkInterface[];
  customer_id?: string;
  name: string; // name
  birthdate: string;
  gender: string;
  national_id: string;
  issuing_organ: string;
  fiscal_number: string;
  mother_name: string;
  nationality: string;
  address: {
    postal_code: string;
    street: string;
    number: string;
    district: string;
    city: string;
    state: string;
    complement: string;
    geolocation?: { latitude: number; longitude: number };
  };
  email: string; // email
  phones: [
    {
      cellnumber?: string;
      number?: string;
      telegram: boolean;
      whatsapp: boolean;
    }
  ];
  phone: string;
  cellphone: string;
  user_type_id: string | UserTypeInterface;
  profession_id?: ProfessionUserInterface | string;
  main_specialty_id?: any;
  specialties: (SpecialtiesUserInterface | {})[];
  council?: string;
  council_id?: {
    _id: string;
    company_id: { _id: string };
    name: string;
    describe?: string;
    initials?: string;
    active?: boolean;
  };
  council_state: string;
  council_number: string;
  verified: string;
  username?: string;
  password?: string;
  active: boolean; // active
  professions: ProfessionUserInterface[];
  user_type?: string;
  user_types?: UserTypesInterface[];
}

export interface UserList {
  data: UserListItems[];
  limit: string;
  page: string;
  total: number;
  search?: string;
  profession_id?: string;
}

export interface ViacepDataInterface {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  erro?: boolean;
}

export interface UpdateCompaniesLinksBody {
  _id: string;
  user_external_id?: string;
  function?: string;
  main_specialty?: string;
  specialities?: String[];
  concil?: string;
  concil_state?: string;
  concil_number?: string | number;
  username?: string;
}

export interface UpdateCompaniesLinksPayload {
  type: typeof UserTypes.LOAD_UPDATE_COMPANIES_LINKS;
  payload: UpdateCompaniesLinksBody;
}

export interface UpdateCompaniesBody {
  _id: string;
  company_id?: string;
}

export interface UpdateCompaniesPayload {
  type: typeof UserTypes.LOAD_UPDATE_COMPANIES;
  payload: UpdateCompaniesBody;
}

export interface UserByExternalIdPayload {
  type: typeof UserTypes.LOAD_REQUEST_BY_EXTERNAL_ID;
  payload: {
    id: string;
  };
}

export interface StoreUserBody {
  name: string;
  email: string;
  fiscal_number: string;
  user_external_id: string;
  username: string;
  main_specialty: { id: string | number; name: string };
  specialties: [];
  function: { id: string | number; name: string };
  council: string;
  council_state: { describe: string };
  council_number: string;
}

export interface UpdateUserBody extends StoreUserBody {
  _id: string;
  reset_password: boolean;
}

export interface StoreUserPayload {
  type: typeof UserTypes.LOAD_REQUEST_STORE_USER;
  payload: StoreUserBody;
}

export interface UpdateUserPayload {
  type: typeof UserTypes.LOAD_REQUEST_UPDATE_USER;
  payload: UpdateUserBody;
}

export interface ExternalUserInterface {
  council: string;
  council_number: string;
  council_state: string;
  ds_email: string;
  fiscal_number: string;
  main_specialty: string;
  main_specialty_id: string;
  name: string;
  user_function: string;
  user_id: string;
  user_function_id: string;
  username: string;
  provider_id: string;
}

/**
 * State type
 */
export interface UserState {
  data: UserInterface;
  list: UserList;
  external?: ExternalUserInterface;
  loading: boolean;
  error: boolean;
  success: boolean;
  errorCep?: boolean;
  successRecovery: boolean;
}

export type LoadRequestParams = Partial<Omit<UserList, "data">>;
